module.exports = __webpack_public_path__ + "img/ac8_thumb.961e879c.jpg";